// ============================================================
// Anker Solix S2000 Portable Power Station LP — v2
// Shopify テーマ移植版 (sections/page-anker-solix-s2000.liquid)
// ============================================================

// テーマの祖先ラッパーが transform/filter/contain を持っていると
// 内側の position:sticky / fixed が viewport ではなく祖先基準になる。
// .s2000-root より上のラッパーを走査して、レイアウト破壊要因を全て解除する。
(() => {
  const root = document.querySelector('.s2000-root');
  if (!root) return;
  let cursor = root.parentElement;
  while (cursor && cursor !== document.documentElement) {
    const cs = getComputedStyle(cursor);
    if (cs.overflow !== 'visible') cursor.style.setProperty('overflow-y', 'visible', 'important');
    if (cs.transform !== 'none')   cursor.style.setProperty('transform', 'none', 'important');
    if (cs.filter !== 'none')      cursor.style.setProperty('filter', 'none', 'important');
    if (cs.contain !== 'none' && cs.contain !== 'normal') cursor.style.setProperty('contain', 'none', 'important');
    cursor = cursor.parentElement;
  }
})();

// ============================================
// Anker Solix S2000 LP — main.js
// ============================================

(() => {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // -----------------------------------------------
  // KV: ファーストビューに収める — KV の上端 (= テーマヘッダーの下端) を測って CSS 変数に渡す (PC のみ CSS 側で使用)
  // -----------------------------------------------
  (() => {
    const kv = document.querySelector('.sec-kv');
    if (!kv) return;
    const measure = () => {
      if (window.scrollY > 0) return;                       // スクロール後は測らない (ヘッダーが sticky で縮むため)
      const top = Math.max(0, Math.round(kv.getBoundingClientRect().top));
      kv.style.setProperty('--s2000-kv-top', top + 'px');
    };
    measure();
    window.addEventListener('load', measure, { once: true });
    window.addEventListener('resize', measure);
  })();

  // -----------------------------------------------
  // KV: 停電フリッカー — viewport 入域時に1度だけ発火 (繰り返しなし)
  // -----------------------------------------------
  (() => {
    const kv = document.querySelector('.sec-kv');
    const bright = document.querySelector('.sec-kv__bg--bright');
    if (!kv || !bright || reduceMotion) {
      if (bright && reduceMotion) bright.classList.add('is-spent');
      return;
    }
    const CYCLE_MS = 2900;            // CSS の animation 時間と合わせる

    const playOnce = () => {
      bright.classList.remove('is-spent', 'is-flicker');
      void bright.offsetWidth;        // reflow で animation を確実に再スタート
      bright.classList.add('is-flicker');
      const done = () => {
        bright.removeEventListener('animationend', done);
        bright.classList.remove('is-flicker');
        bright.classList.add('is-spent');
      };
      bright.addEventListener('animationend', done, { once: true });
      setTimeout(done, CYCLE_MS + 400); // 念のためのフォールバック
    };

    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && e.intersectionRatio > 0.2) {
          playOnce();
          io.disconnect();             // 1度きり
        }
      });
    }, { threshold: [0, 0.2, 0.5] });
    io.observe(kv);
  })();

  // -----------------------------------------------
  // 04-05 ライフスタイル: 背景 (life-bg--b) をスクロール進行度で fade-in
  // -----------------------------------------------
  const lifeSection = document.querySelector('[data-life-scroll]');
  if (lifeSection) {
    const bgB = lifeSection.querySelector('.life-bg--b');
    const lifeContentEl = lifeSection.querySelector('.life-content');
    let lTicking = false;
    const lifeUpdate = () => {
      const rect = lifeSection.getBoundingClientRect();
      const totalScroll = rect.height - window.innerHeight;
      const raw = -rect.top / Math.max(totalScroll, 1);
      const progress = Math.max(0, Math.min(1, raw));
      // bg-b は 0.30〜0.80 で 0→1 (前後にホールド時間を確保、中央でゆっくり切替)
      const t = Math.max(0, Math.min(1, (progress - 0.30) / 0.50));
      // smoothstep で中央域をじわっと
      const eased = t * t * (3 - 2 * t);
      if (bgB) bgB.style.opacity = eased.toFixed(3);
      // bg-a/b に微ズーム (ケンバーンズ) で背景に「動き」を加える
      const bgA = lifeSection.querySelector('.life-bg--a');
      if (!reduceMotion) {
        if (bgA) bgA.style.transform = `scale(${(1 + progress * 0.05).toFixed(4)})`;
        if (bgB) bgB.style.transform = `scale(${(1.05 - progress * 0.05).toFixed(4)})`;
      }
      // 文字全体に統一 drag (heading と detail の関係は崩さない)
      if (!reduceMotion && lifeContentEl) {
        const drag = progress * window.innerHeight * 0.12;   // 約12vh
        lifeContentEl.style.transform = `translate3d(0, ${drag.toFixed(1)}px, 0)`;
      }
      lTicking = false;
    };
    const lifeOnScroll = () => {
      if (!lTicking) { requestAnimationFrame(lifeUpdate); lTicking = true; }
    };
    window.addEventListener('scroll', lifeOnScroll, { passive: true });
    window.addEventListener('resize', lifeOnScroll, { passive: true });
    lifeUpdate();
  }

  // -----------------------------------------------
  // big-num 静的表示 (スロットアニメ廃止)
  // -----------------------------------------------
  document.querySelectorAll('.big-num').forEach((el) => {
    const num = el.dataset.num || '01';
    const slot = el.querySelector('[data-num-static]');
    if (slot) slot.textContent = num;
    el.classList.add('is-played');
    el.dataset.played = '1';
  });
  const triggerSlot = (el) => {
    el.classList.add('is-played');
    el.dataset.played = '1';
  };

  // -----------------------------------------------
  // OptiSave tooltip: タップで開閉、外側タップで閉じる
  // -----------------------------------------------
  document.querySelectorAll('.optisave-tip').forEach((tip) => {
    tip.setAttribute('role', 'button');
    tip.setAttribute('aria-expanded', 'false');
    tip.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = tip.classList.toggle('is-open');
      tip.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    tip.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { tip.classList.remove('is-open'); tip.setAttribute('aria-expanded', 'false'); }
    });
  });
  document.addEventListener('click', () => {
    document.querySelectorAll('.optisave-tip.is-open').forEach((t) => {
      t.classList.remove('is-open');
      t.setAttribute('aria-expanded', 'false');
    });
  });

  // -----------------------------------------------
  // counter アニメ
  // HTML には最終値をそのまま書いておく（SEO: 検索結果の snippet が
  // JS 発火前の「0%」を拾う事故があったため）。0 に戻すのは
  // アニメ開始の瞬間だけ。
  // -----------------------------------------------
  const ease = (t) => 1 - Math.pow(1 - t, 3);
  const triggerCounter = (el) => {
    if (el.dataset.played === '1') return;
    el.dataset.played = '1';
    const target = parseInt(el.dataset.counterTarget, 10);
    const duration = 1500;
    if (reduceMotion) { el.textContent = String(target); return; }
    el.textContent = '0';
    const start = performance.now();
    const step = (now) => {
      const t = Math.min(1, (now - start) / duration);
      el.textContent = String(Math.round(ease(t) * target));
      if (t < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  // -----------------------------------------------
  // .stack — 02-04 は通常フローの 1 画面高セクション (9/10 ピン留め廃止)。
  //   表示領域に 30% 入ったら is-active (入場演出 + 数字スロット + カウンター)。一度活性化したら戻さない
  // -----------------------------------------------
  const stacks = document.querySelectorAll('[data-stack]');
  stacks.forEach(stack => {
    const panels = Array.from(stack.querySelectorAll('.stack__panel'));
    if (!panels.length) return;
    const activate = (p) => {
      if (p.classList.contains('is-active')) return;
      p.classList.add('is-active');
      const bigNum = p.querySelector('.big-num');
      if (bigNum) triggerSlot(bigNum);
      p.querySelectorAll('[data-counter-target]').forEach(triggerCounter);
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(en => { if (en.isIntersecting) { activate(en.target); io.unobserve(en.target); } });
      }, { threshold: 0.3 });
      panels.forEach(p => io.observe(p));
    } else {
      panels.forEach(activate);
    }

    // #feat-03 等で着地した場合、画像/KV の高さ確定後に位置がずれるので改めて送る
    const id = decodeURIComponent((location.hash || '').slice(1));
    const target = id ? panels.find(p => p.id === id) : null;
    if (target) window.addEventListener('load', () => setTimeout(() => target.scrollIntoView({ block: 'start' }), 150));
  });

  // -----------------------------------------------
  // Feature 統合インジケータ (Feature 01 + Stack 02-04)
  //   4 dots: 01 (feat-01), 02-04 (stack panels)
  //   fixed配置、feat-01 or stack が viewport にある時のみ表示
  // -----------------------------------------------
  const featIndicator = document.querySelector('[data-feat-indicator]');
  const feat01 = document.querySelector('#feat-01');
  const featStack = document.querySelector('.stack--feat');
  if (featIndicator && feat01 && featStack) {
    const dots = Array.from(featIndicator.querySelectorAll('.feat-indicator__dot'));
    let fiTicking = false;
    const featEls = [feat01, ...Array.from(featStack.querySelectorAll('.stack__panel'))];
    const fiUpdate = () => {
      const vh = window.innerHeight;
      let activeIdx = -1;
      let anyIn = false;
      featEls.forEach((el, i) => {
        const r = el.getBoundingClientRect();
        if (r.bottom > vh * 0.2 && r.top < vh * 0.8) anyIn = true;
        if (r.top <= vh * 0.5 && r.bottom > vh * 0.5) activeIdx = i;
      });
      featIndicator.classList.toggle('is-visible', anyIn);
      dots.forEach((d, i) => d.classList.toggle('is-active', i === activeIdx));
      fiTicking = false;
    };
    const fiOnScroll = () => {
      if (!fiTicking) { requestAnimationFrame(fiUpdate); fiTicking = true; }
    };
    window.addEventListener('scroll', fiOnScroll, { passive: true });
    window.addEventListener('resize', fiOnScroll, { passive: true });
    // ドットクリックで対応位置へスクロール
    dots.forEach((d, i) => {
      d.addEventListener('click', () => {
        const el = featEls[i];
        if (el) el.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
    });
    fiUpdate();
  }

  // -----------------------------------------------
  // スタック外の big-num / counter は IntersectionObserver で起動
  // -----------------------------------------------
  const outsideBigNums = document.querySelectorAll('.big-num');
  const obsBig = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        triggerSlot(entry.target);
        obsBig.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });
  outsideBigNums.forEach(el => {
    if (el.closest('.stack')) return;     // スタック内はスタック制御に任せる
    obsBig.observe(el);
  });

  const outsideCounters = document.querySelectorAll('[data-counter-target]');
  const obsCount = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        triggerCounter(entry.target);
        obsCount.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }); // reveal と同時に発火（最終値がチラ見えしないよう）
  outsideCounters.forEach(el => {
    if (el.closest('.stack')) return;
    obsCount.observe(el);
  });

  // -----------------------------------------------
  // 汎用 reveal
  // -----------------------------------------------
  const reveals = document.querySelectorAll('[data-reveal], [data-reveal-scale], [data-stagger], [data-reveal-heading], [data-anim]');
  if (reveals.length) {
    const revObs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          revObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
    reveals.forEach(el => revObs.observe(el));
  }

  // -----------------------------------------------
  // 汎用パララックス: data-parallax
  // -----------------------------------------------
  const parallaxItems = Array.from(document.querySelectorAll('[data-parallax]'));
  if (parallaxItems.length && !reduceMotion) {
    let pTicking = false;
    const updateParallax = () => {
      const vh = window.innerHeight;
      parallaxItems.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.bottom < -100 || rect.top > vh + 100) return;
        const speed = parseFloat(el.dataset.parallax) || 0.3;
        const center = rect.top + rect.height / 2;
        const fromCenter = (center - vh / 2) / (vh / 2);
        const ty = fromCenter * speed * 80;
        el.style.transform = `translate3d(0, ${ty.toFixed(2)}px, 0)`;
      });
      pTicking = false;
    };
    const onScroll = () => {
      if (!pTicking) { requestAnimationFrame(updateParallax); pTicking = true; }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateParallax();
  }


  // -----------------------------------------------
  // v3: 製品特徴ナビゲーション (CRF p.6)
  //   KV を通過したら表示。
  //   feat-02〜04 は sticky stack 内にあり getBoundingClientRect が
  //   動かないため、既存の feat-indicator と同じ進行度計算で現在地を判定する。
  // -----------------------------------------------
  (() => {
    const nav = document.querySelector('[data-lp-nav]');
    if (!nav) return;
    const links = Array.from(nav.querySelectorAll('[data-lp-nav-link]'));
    const kv = document.querySelector('.sec-kv');
    const lpRoot = document.querySelector('.s2000-root');
    const f01 = document.querySelector('#feat-01');
    const stack = document.querySelector('.stack--feat');
    const scene = document.querySelector('#scene');
    let ticking = false;

    const setActive = (href) => {
      links.forEach(a => a.classList.toggle('is-active', a.getAttribute('href') === href));
    };

    const update = () => {
      const vh = window.innerHeight;
      const kvBottom = kv ? kv.getBoundingClientRect().bottom : 0;
      // LP の末尾がナビの高さより上に抜けたら (= フッターに入ったら) ナビは引き上げる
      const lpBottom = lpRoot ? lpRoot.getBoundingClientRect().bottom : Infinity;
      nav.classList.toggle('is-visible', kvBottom < 0 && lpBottom > nav.offsetHeight);

      let current = '';
      if (f01) {
        const r = f01.getBoundingClientRect();
        if (r.top < vh * 0.5 && r.bottom > vh * 0.2) current = '#feat-01';
      }
      if (stack) {
        stack.querySelectorAll('.stack__panel').forEach(p => {
          const r = p.getBoundingClientRect();
          if (r.top <= vh * 0.5 && r.bottom > vh * 0.2) current = '#' + p.id;
        });
      }
      if (scene) {
        const r = scene.getBoundingClientRect();
        if (r.top < vh * 0.5 && r.bottom > vh * 0.2) current = '#scene';
      }
      setActive(current);
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // 02-04 は通常フローになったのでナビのアンカーはブラウザ標準に任せる (scroll-margin-top で固定ナビ分を確保)

    update();
  })();

  // -----------------------------------------------
  // v3: タブ切り替え (おすすめシーン / インフルエンサー動画)
  // -----------------------------------------------
  const setupTabs = (tabAttr, panelAttr, onChange) => {
    const tabs = Array.from(document.querySelectorAll(`[${tabAttr}]`));
    if (!tabs.length) return;
    const panels = Array.from(document.querySelectorAll(`[${panelAttr}]`));

    const activate = (key, focus) => {
      tabs.forEach(t => {
        const on = t.getAttribute(tabAttr) === key;
        t.classList.toggle('is-current', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach(p => {
        const on = p.getAttribute(panelAttr) === key;
        p.classList.toggle('is-current', on);
        p.hidden = !on;
      });
      if (typeof onChange === 'function') onChange(key);
    };

    tabs.forEach((t, i) => {
      t.addEventListener('click', () => activate(t.getAttribute(tabAttr)));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        const dir = e.key === 'ArrowRight' ? 1 : -1;
        const next = tabs[(i + dir + tabs.length) % tabs.length];
        activate(next.getAttribute(tabAttr), true);
      });
    });
  };

  // -----------------------------------------------
  // v3: シーンカルーセル (scroll-snap + 矢印 + ドット)
  // -----------------------------------------------
  const carousels = [];
  document.querySelectorAll('[data-carousel]').forEach(root => {
    const track = root.querySelector('[data-carousel-track]');
    const slides = track ? Array.from(track.children) : [];
    if (!track || slides.length === 0) return;

    const dotsWrap = root.querySelector('[data-carousel-dots]');
    const prev = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    const dots = [];

    if (dotsWrap) {
      slides.forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'scene-carousel__dot';
        b.setAttribute('aria-label', `${i + 1}枚目へ`);
        b.addEventListener('click', () => goTo(i));
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }

    const currentIndex = () => {
      const base = slides[0].offsetLeft;
      let best = 0;
      let min = Infinity;
      slides.forEach((s, i) => {
        const d = Math.abs((s.offsetLeft - base) - track.scrollLeft);
        if (d < min) { min = d; best = i; }
      });
      return best;
    };

    const goTo = (i) => {
      const idx = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[idx].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    };

    const sync = () => {
      const i = currentIndex();
      dots.forEach((d, di) => d.classList.toggle('is-current', di === i));
      const maxScroll = track.scrollWidth - track.clientWidth;
      // 全スライドが収まっている (スクロール余地なし) なら矢印・ドットごと隠す
      root.classList.toggle('is-static', maxScroll <= 2);
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= maxScroll - 1;
    };

    if (prev) prev.addEventListener('click', () => goTo(currentIndex() - 1));
    if (next) next.addEventListener('click', () => goTo(currentIndex() + 1));
    track.addEventListener('scroll', () => {
      window.clearTimeout(track._syncTimer);
      track._syncTimer = window.setTimeout(sync, 80);
    }, { passive: true });
    window.addEventListener('resize', sync, { passive: true });

    carousels.push({ root, sync });
    sync();
  });

  const syncCarousels = () => carousels.forEach(c => {
    // 非表示パネル内は幅が 0 のため、表示された直後に再計算する
    if (c.root.offsetParent !== null) c.sync();
  });

  setupTabs('data-scene-tab', 'data-scene-panel', () => requestAnimationFrame(syncCarousels));
  setupTabs('data-sns-tab', 'data-sns-panel');

})();
